import { render } from "./Record.vue?vue&type=template&id=77af261e&scoped=true"
import script from "./Record.vue?vue&type=script&lang=js"
export * from "./Record.vue?vue&type=script&lang=js"

import "./Record.vue?vue&type=style&index=0&id=77af261e&scoped=true&lang=scss"
import "./Record.vue?vue&type=style&index=1&id=77af261e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77af261e"]])

export default __exports__